import { cn } from "@/lib/utils";

type SpinnerSize = "sm" | "md" | "lg" | "xl";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  className?: string;
  variant?: "default" | "inverted";
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: "h-4 w-4 border-2", // 16px - inline, buttons
  md: "h-5 w-5 border-2", // 20px - default
  lg: "h-8 w-8 border-2", // 32px - sections, modals
  xl: "h-10 w-10 border-2", // 40px - full page
};

export function Spinner({
  size = "md",
  className,
  variant = "default",
  ...props
}: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(
        "animate-spin rounded-full",
        sizeClasses[size],
        variant === "default"
          ? "border-neutral-200 border-t-blue-500"
          : "border-white/30 border-t-white",
        className
      )}
      {...props}
    />
  );
}
